function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C9.38 2 7.25 4.13 7.25 6.75c0 2.57 2.01 4.65 4.63 4.74.08-.01.16-.01.22 0h.07a4.738 4.738 0 004.58-4.74C16.75 4.13 14.62 2 12 2z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.08 14.15c-2.79-1.86-7.34-1.86-10.15 0-1.27.85-1.97 2-1.97 3.23s.7 2.37 1.96 3.21C8.32 21.53 10.16 22 12 22c1.84 0 3.68-.47 5.08-1.41 1.26-.85 1.96-1.99 1.96-3.23-.01-1.23-.7-2.37-1.96-3.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.06 17.38l.88-.88c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-.88.88-.88-.88a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l.88.88-.88.88c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l.88-.88.88.88c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-.88-.88z"
})));